import { ReducerFunctions } from "../../utils";
import { CreateBeneficiary, GetBeneficiary, GetByBeneficiary } from "./beneficiary";

export const get_beneficiary_reducer = ReducerFunctions(GetBeneficiary, {});
export const create_beneficiary_reducer = ReducerFunctions(CreateBeneficiary, {});
export const get_by_id_beneficiary_reducer = ReducerFunctions(GetByBeneficiary, {});